// src/screen/user/pages/PageTemplate.js
import React from 'react';
import '../../../../assests/css/customer/Footer/PageTemplate.css';


const PageTemplate = ({ title, children }) => {
  return (
    <div className="page-template">
      <h1 className="page-title">{title}</h1>
      <div className="page-content">{children}</div>
    </div>
  );
};

export default PageTemplate; // ✅ default export
